import type { RouteObject } from "react-router";

import { CancelPage } from "./cancel-page.js";
import { CardPage } from "./card-page.js";
import { ChangePlanPage } from "./change-plan-page.js";
import { PlanChangedPage, SignupCompletedPage } from "./completed-page.js";
import { EditPage } from "./edit-page.js";
import { IpRestrictionPage } from "./ip-restriction-page.js";
import { SignupPage } from "./signup-page.js";
import { TenantDetailPage } from "./tenant-detail-page.js";
import { TenantListPage } from "./tenant-list-page.js";

/** 契約（一覧・契約情報・申し込み・プラン変更・契約内容の変更・カード情報の変更・接続を許可する IP アドレス・解約）。<b>足したら paths/tenants.json にも足す。</b> */
export const tenantRoutes: RouteObject[] = [
    { path: "/Tenant", element: <TenantListPage /> },
    { path: "/Tenant/New", element: <SignupPage /> },
    { path: "/Tenant/Detail/:tenantId", element: <TenantDetailPage /> },
    { path: "/Tenant/Completed/:tenantId", element: <SignupCompletedPage /> },
    { path: "/Tenant/Completed/:tenantId/PlanChanged", element: <PlanChangedPage /> },
    { path: "/Tenant/ChangePlan/:tenantId", element: <ChangePlanPage /> },
    { path: "/Tenant/Edit/:tenantId", element: <EditPage /> },
    { path: "/Tenant/Card/:tenantId", element: <CardPage /> },
    { path: "/Tenant/IpRestriction/:tenantId", element: <IpRestrictionPage /> },
    { path: "/Tenant/Delete/:tenantId", element: <CancelPage /> },
];
